import { render, staticRenderFns } from "./project-summary.vue?vue&type=template&id=248e5541&"
import script from "./project-summary.vue?vue&type=script&lang=js&"
export * from "./project-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports